import { immer } from "zustand/middleware/immer";

import { UserDetailedInfo } from "@/types";
import { createStore } from "@/utils";

type OnboardingState = {
  userInfo: Partial<UserDetailedInfo>;
  userImageFormData?: FormData;
  isPhotoVerified?: boolean;
  currentStep: number;
  passedSteps: number[];
  referralCode?: string;
};

type OnboardingActions = {
  actions: {
    setInfo: (data: OnboardingState["userInfo"]) => void;
    setCurrentStep: (step: number) => void;
    setUserImageFD: (data: OnboardingState["userImageFormData"]) => void;
    setIsPhotoVerified: (value: OnboardingState["isPhotoVerified"]) => void;
    setReferralCode: (value: OnboardingState["referralCode"]) => void;
    addPassedStep: (value: number) => void;
  };
};

const defaultOnboardingValues: OnboardingState = {
  userInfo: {},
  currentStep: 0,
  passedSteps: [],
};

const useOnboardingStore = createStore<OnboardingState & OnboardingActions>(
  immer((set) => ({
    ...defaultOnboardingValues,
    actions: {
      setInfo: (data) =>
        set((state) => {
          state.userInfo = { ...state.userInfo, ...data };
        }),
      setCurrentStep: (step) =>
        set((state) => {
          state.currentStep = step;
        }),
      setReferralCode: (referralCode) =>
        set((state) => {
          state.referralCode = referralCode;
        }),
      setUserImageFD: (data) =>
        set((state) => {
          state.userImageFormData = data;
        }),
      setIsPhotoVerified: (value) =>
        set((state) => {
          state.isPhotoVerified = value;
        }),
      addPassedStep: (value) =>
        set((state) => {
          if (!state.passedSteps.includes(value)) {
            state.passedSteps.push(value);
          }
        }),
    },
  }))
);

export { useOnboardingStore };
